module.exports = __webpack_public_path__ + "img/267-1.3e5906fc.jpg";